export const state = () => ({
  requestsRunning: 0,
})
